module.exports = __webpack_public_path__ + "img/image12.3fd3355c.jpeg";